"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatus = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_router_1 = require("react-router");
const strings_1 = require("../../../../../constants/strings");
const approvalQuery_1 = require("../../../../../queries/approvals/approvalQuery");
const approvalsUtils_1 = require("../../../../../queries/approvals/approvalsUtils");
const Root_1 = require("../../../../../router/Root");
const zustandStore_1 = require("../../../../../zustandStore");
const lexico = new lexico_1.default();
const getStatus = (approval) => {
    let approvalStatus = (0, approvalsUtils_1.getApprovalStatus)(approval);
    if (approvalStatus === 'pending' && approval.reassignedByUser !== undefined) {
        approvalStatus = 'pending-forwarded';
    }
    return approvalStatus;
};
exports.getStatus = getStatus;
const ReassignButton = ({ approvalItem }) => {
    const params = (0, react_router_1.useParams)();
    const { setDialog, setPageLoading, setNotification, setShowConversationButtons } = (0, zustandStore_1.useZustand)();
    const user = (0, zustandStore_1.useZustand)(state => state.user);
    const viewAllApprovals = (0, zustandStore_1.useZustand)(state => state.activity.viewAllApprovals);
    const isActivityOrConversationPage = globalThis.location.pathname.includes('activity') || globalThis.location.pathname.includes('approval');
    const { featureAccess, outcome } = approvalItem || {};
    const status = (0, exports.getStatus)(approvalItem);
    const isReassignableToSelf = featureAccess &&
        featureAccess.reassignRequestToSelf &&
        (status === 'pending-forwarded' || status === 'forwarded-pending');
    const reassignRequestMutation = (0, approvalQuery_1.useForwardRequestMutation)();
    const reassignRequest = () => {
        const payload = {
            assignee: user,
            approval: approvalItem,
            previousAssignee: approvalItem.reassignedToUser,
        };
        setDialog({
            type: strings_1.notificationStrings.INFO,
            message: strings_1.approvalsStrings.REASSIGN_MESSAGE,
            open: true,
            actionText: 'OK',
            showCancel: true,
            onAccept: () => {
                setPageLoading(true);
                reassignRequestMutation.mutate(payload, {
                    onSuccess: () => {
                        setShowConversationButtons(true);
                        setNotification([
                            {
                                type: strings_1.notificationStrings.SUCCESS,
                                message: lexico.tr('Request reassigned'),
                            },
                        ]);
                    },
                    onSettled: () => {
                        if (params?.['approvalId']) {
                            void Root_1.queryClient.invalidateQueries({
                                queryKey: ['approval', params?.['approvalId']],
                            });
                        }
                        setPageLoading(false);
                    },
                });
            },
        });
    };
    const showBtn = isReassignableToSelf &&
        outcome === 'REASSIGNED' &&
        isActivityOrConversationPage &&
        !viewAllApprovals &&
        !approvalItem.currentUserIsNotAssigneerByUserId;
    return (showBtn && ((0, jsx_runtime_1.jsx)(material_1.Button, { name: "reassign", variant: "contained", style: {
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? { textTransform: 'uppercase' } : {}),
        }, color: "secondary", onClick: reassignRequest, children: lexico.trc('Button', 'Reassign') })));
};
exports.default = ReassignButton;
